module.exports = require("/builds/ethicadata/frontend/projects/landing-page/src/components/root-wrapper/styles-provider-props")